export const EmailCss = () => {
  return (
    <style>{`
        p {
            margin: 0;
        }
    `}</style>
  );
};
